import { VideoRepresentation } from '../types';

export const getVideoPrivacyDomainRestrictionsValue = (
  video: VideoRepresentation
) => video.privacy_settings?.domain_restrictions || 'off';
